import { useMemo } from 'react'
import { useColorScheme } from '@mui/material/styles'
import QRCode from "react-qr-code"

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/download-scanner-apps'

import appstoreButtonDark from '/assets/images/download-from-apple-appstore-dark.svg'
import appstoreButtonLight from '/assets/images/download-from-apple-appstore-light.svg'

import playStoreButton from '/assets/images/GetItOnGooglePlay_Badge_Web_color_English.svg'
import { Typography } from '@mui/material'

import config from '/providers/config.json'
import StyledPaper from '../components/paper.jsx'

const DownloadScannerApps = () => {

  const { mode, systemMode } = useColorScheme()

  const themeMode = useMemo(() => {
    if (mode === "system") return systemMode
    return mode
  }, [mode, systemMode])

  const appstoreButton = useMemo(() => themeMode === "dark" ? appstoreButtonDark : appstoreButtonLight, [themeMode])

  return (
    <PageWrapper title="Download Apps" HelpText={HelpText} heading="Download Smartix Scan mobile App">
      <div className='flex flex-row w-full justify-center gap-10 p-20'>
        <div className='flex flex-col gap-10 items-center justify-center'>
          <StyledPaper>
            <div className='w-[500px] p-10'>
              <div className='text-nowrap'>
                <Typography variant='h2'>Smartix Scan</Typography>
              </div>
              <p>Smartix Scan enables you to scan and process any passes created from a Smartix Managed Template.</p>
              <p>For example, you can add stamps to stampcards, redeem giftcards and manage entry to events.</p>
              <p>Scan the barcodes with your phone to download from the App Stores.</p>
            </div>
          </StyledPaper>
        </div>

        <div className='self-center'>
          <StyledPaper sx={{ padding: 5 }}>
            <div className='flex flex-row w-full h-full justify-around gap-10'>

              <div className='flex flex-col gap-10 items-center justify-center'>
                <a href={config.appleAppUrl} target='_blank'><img src={appstoreButton} width={200} /></a>
                <div className='bg-white p-5'>
                  <QRCode
                    size={200}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={config.appleAppUrl}
                    viewBox={`0 0 200 200`}
                  />
                </div>
              </div>

              <div className='flex flex-col gap-10 items-center justify-center'>
                <a href={config.googleAppUrl} target='_blank'><img src={playStoreButton} width={200} /></a>
                <div className='bg-white p-5'>
                  <QRCode
                    size={200}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={config.googleAppUrl}
                    viewBox={`0 0 200 200`}
                  />
                </div>
              </div>
            </div>
          </StyledPaper>
        </div>
      </div>
    </PageWrapper>
  )
}

export default DownloadScannerApps